import React from 'react';
import './AiPlayerMark.css';
import {getBotMarkIconPath} from '../../utils/bots/getBotMarkIconPath';
import {getVisibleBotTitle} from '../../utils/bots/getVisibleBotTitle';
import {getBotMarkAlt} from '../../utils/bots/getBotMarkAlt';

// Иконка, alt и подпись метки ИИ — теми же помощниками, что и у значка на
// иконке фракции (VisibleBotMark): метка ИИ везде одна и та же
const AI_PLAYER = {isAi: true};

/**
 * Метка ИИ-игрока промо-матча «Битва с AI» в строке текста — после никнейма в
 * Зале славы, в поздравлении победителя, в заголовке профиля. В отличие от
 * VisibleBotMark (угол иконки фракции) стоит в потоке текста и по размеру
 * подстраивается под шрифт строки.
 */
const AiPlayerMark = ({className = ''}) => (
  <img
    className={`ai-player-mark ${className}`.trim()}
    src={getBotMarkIconPath(AI_PLAYER)}
    alt={getBotMarkAlt(AI_PLAYER)}
    title={getVisibleBotTitle(AI_PLAYER)}
  />
);

export default AiPlayerMark;
